export default __webpack_public_path__ + "static/media/main.84226f11.png";